import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from '../brand/BrandLogo';

const AuthShell = ({ children, footer }) => (
  <div className="min-h-screen bg-neutral-100 flex flex-col items-center justify-center px-4 py-10">
    <div className="w-full max-w-lg">
      <div className="flex justify-center mb-6">
        <BrandLogo size="lg" imgClassName="rounded-lg shadow-sm" />
      </div>
      <div className="bg-white rounded-xl border border-gray-200/80 shadow-sm px-8 py-8 sm:px-10 sm:py-10">
        {children}
      </div>
      {footer}
    </div>
  </div>
);

export const AuthHeader = ({ title, subtitle }) => (
  <div className="text-center mb-8">
    <h1 className="text-2xl font-bold text-gray-900 tracking-tight">{title}</h1>
    {subtitle && <p className="text-sm text-gray-500 mt-2">{subtitle}</p>}
  </div>
);

export const AuthFooterLink = ({ prompt, linkText, to }) => (
  <p className="text-center text-sm text-gray-500 mt-6">
    {prompt}{' '}
    <Link to={to} className="font-semibold text-gray-900 hover:underline">
      {linkText}
    </Link>
  </p>
);

export const AuthSubmitButton = ({ children, loading, loadingText, disabled }) => (
  <button
    type="submit"
    disabled={disabled || loading}
    className="w-full mt-2 bg-gray-900 hover:bg-black text-white py-3 rounded-lg text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
  >
    {loading ? (
      <span className="flex items-center justify-center gap-2">
        <span className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent" />
        {loadingText}
      </span>
    ) : (
      children
    )}
  </button>
);

export const AuthError = ({ message }) =>
  message ? (
    <div className="mb-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2.5">
      <p className="text-red-600 text-sm">{message}</p>
    </div>
  ) : null;

export const AuthSuccess = ({ message }) =>
  message ? (
    <div className="mb-4 rounded-lg border border-green-200 bg-green-50 px-3 py-2.5">
      <p className="text-green-700 text-sm">{message}</p>
    </div>
  ) : null;

export const AuthBackHome = () => (
  <p className="text-center mt-5">
    <Link to="/" className="text-sm text-gray-500 hover:text-gray-800 transition-colors">
      ← Back to home
    </Link>
  </p>
);

export default AuthShell;
